import { ArrowUpIcon } from '@/assets/images/icons';
import { StyledCaret } from './Caret.styles';

export const CaretUp: React.FC = () => {
  return <StyledCaret src={ArrowUpIcon} alt="" />;
};
